import { CustomCellRendererProps } from 'ag-grid-react'

import { useWrapperBucketsQuery } from '@/react-query/queries/static'

export interface WrapperBucketIdCellRendererProps extends CustomCellRendererProps {}

export const WrapperBucketIdCellRenderer: React.FC<WrapperBucketIdCellRendererProps> = ({
  value,
}) => {
  const query = useWrapperBucketsQuery()

  const label = value ? (query.data?.find((c) => c.value == value)?.label ?? value) : null

  return <>{label}</>
}
